"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsiteHub = exports.WebhookHub = exports.VoucherHub = exports.TeammateHub = exports.StoreHub = exports.StoreGroupHub = exports.PrinterHub = exports.PhoneCallHub = exports.OrderHub = exports.MenuHub = exports.MenuCheckpointHub = exports.HydraHub = exports.CustomerHub = exports.CardReaderHub = exports.CampaignHub = exports.BankAccountHub = exports.AppHub = exports.AnalyticsHub = exports.AuthorizationHub = exports.AuthorizationReply = exports.SignalR = exports.SignalRConfiguration = void 0;
var signalr_no_jquery_1 = require("@flipdish/signalr-no-jquery");
var defaultBasePath = "https://api-principal-b.portal.flipdishdev.com";
var SignalRConfiguration = (function () {
    function SignalRConfiguration(basePath, bearerToken, log) {
        if (log === void 0) { log = false; }
        this.BasePath = basePath;
        this.BearerToken = bearerToken;
        this.Log = log;
    }
    return SignalRConfiguration;
}());
exports.SignalRConfiguration = SignalRConfiguration;
;
var SignalR = (function () {
    function SignalR(signalRConfiguration) {
        this.signalRConfiguration = signalRConfiguration;
        if (!SignalR.ActiveConnection) {
            SignalR.ActiveConnection = (0, signalr_no_jquery_1.hubConnection)(signalRConfiguration.BasePath ? signalRConfiguration.BasePath : defaultBasePath);
        }
        this.AuthorizationHub = new AuthorizationHub(SignalR.ActiveConnection.createHubProxy('AuthorizationHub'), signalRConfiguration.Log);
        this.AnalyticsHub = new AnalyticsHub(SignalR.ActiveConnection.createHubProxy("AnalyticsHub"), signalRConfiguration.Log);
        this.AppHub = new AppHub(SignalR.ActiveConnection.createHubProxy("AppHub"), signalRConfiguration.Log);
        this.BankAccountHub = new BankAccountHub(SignalR.ActiveConnection.createHubProxy("BankAccountHub"), signalRConfiguration.Log);
        this.CampaignHub = new CampaignHub(SignalR.ActiveConnection.createHubProxy("CampaignHub"), signalRConfiguration.Log);
        this.CardReaderHub = new CardReaderHub(SignalR.ActiveConnection.createHubProxy("CardReaderHub"), signalRConfiguration.Log);
        this.CustomerHub = new CustomerHub(SignalR.ActiveConnection.createHubProxy("CustomerHub"), signalRConfiguration.Log);
        this.HydraHub = new HydraHub(SignalR.ActiveConnection.createHubProxy("HydraHub"), signalRConfiguration.Log);
        this.MenuCheckpointHub = new MenuCheckpointHub(SignalR.ActiveConnection.createHubProxy("MenuCheckpointHub"), signalRConfiguration.Log);
        this.MenuHub = new MenuHub(SignalR.ActiveConnection.createHubProxy("MenuHub"), signalRConfiguration.Log);
        this.OrderHub = new OrderHub(SignalR.ActiveConnection.createHubProxy("OrderHub"), signalRConfiguration.Log);
        this.PhoneCallHub = new PhoneCallHub(SignalR.ActiveConnection.createHubProxy("PhoneCallHub"), signalRConfiguration.Log);
        this.PrinterHub = new PrinterHub(SignalR.ActiveConnection.createHubProxy("PrinterHub"), signalRConfiguration.Log);
        this.StoreGroupHub = new StoreGroupHub(SignalR.ActiveConnection.createHubProxy("StoreGroupHub"), signalRConfiguration.Log);
        this.StoreHub = new StoreHub(SignalR.ActiveConnection.createHubProxy("StoreHub"), signalRConfiguration.Log);
        this.TeammateHub = new TeammateHub(SignalR.ActiveConnection.createHubProxy("TeammateHub"), signalRConfiguration.Log);
        this.VoucherHub = new VoucherHub(SignalR.ActiveConnection.createHubProxy("VoucherHub"), signalRConfiguration.Log);
        this.WebhookHub = new WebhookHub(SignalR.ActiveConnection.createHubProxy("WebhookHub"), signalRConfiguration.Log);
        this.WebsiteHub = new WebsiteHub(SignalR.ActiveConnection.createHubProxy("WebsiteHub"), signalRConfiguration.Log);
        var extraHeaders = signalRConfiguration.BearerToken ? { extraHeaders: [{ key: "Authorization", value: "Bearer ".concat(signalRConfiguration.BearerToken) }] } : {};
    }
    SignalR.prototype.Start = function (OnConnectionStarted) {
        if (!this.started) {
            if (this.signalRConfiguration.Log) {
                console.log("Starting connection...");
            }
            this.started = true;
            SignalR.ActiveConnection.start(this.extraHeaders, OnConnectionStarted);
            return true;
        }
        else {
            if (this.signalRConfiguration.Log) {
                console.log("Connection already started...");
            }
            return false;
        }
    };
    SignalR.prototype.Stop = function () {
        SignalR.ActiveConnection.stop(false, true);
        SignalR.ActiveConnection = undefined;
    };
    return SignalR;
}());
exports.SignalR = SignalR;
var SignalrEvent = (function () {
    function SignalrEvent() {
    }
    return SignalrEvent;
}());
var AuthorizationReply = (function () {
    function AuthorizationReply() {
    }
    return AuthorizationReply;
}());
exports.AuthorizationReply = AuthorizationReply;
var AuthorizationHub = (function () {
    function AuthorizationHub(proxy, log) {
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("x", function () { });
    }
    AuthorizationHub.prototype.authenticate = function () {
        if (this.log) {
            console.log("Authenticating...");
        }
        return this.proxy.invoke("Authenticate", "1.0");
    };
    return AuthorizationHub;
}());
exports.AuthorizationHub = AuthorizationHub;
var AnalyticsHub = (function () {
    function AnalyticsHub(proxy, log) {
        var _this = this;
        this.AnalyticsClientCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("analytics.website", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.AnalyticsClientCallback) {
                if (_this.log) {
                    console.log("analytics.website received");
                    console.log(eventData.Body);
                }
                _this.AnalyticsClientCallback(data);
            }
        });
    }
    AnalyticsHub.prototype.OnAnalyticsClient = function (callback) {
        if (this.log) {
            console.log("analytics.website subscribed");
        }
        this.AnalyticsClientCallback = callback;
    };
    AnalyticsHub.prototype.OffAnalyticsClient = function (callback) {
        if (this.log) {
            console.log("analytics.website unsubscribed");
        }
        this.AnalyticsClientCallback = undefined;
    };
    return AnalyticsHub;
}());
exports.AnalyticsHub = AnalyticsHub;
var AppHub = (function () {
    function AppHub(proxy, log) {
        var _this = this;
        this.AppCreatedCallback = undefined;
        this.AppUpdatedCallback = undefined;
        this.AppStoreConfigCreatedCallback = undefined;
        this.AppStoreConfigUpdatedCallback = undefined;
        this.AppStoreConfigDeletedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("app.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.AppCreatedCallback) {
                if (_this.log) {
                    console.log("app.created received");
                    console.log(eventData.Body);
                }
                _this.AppCreatedCallback(data);
            }
        });
        this.proxy.on("app.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.AppUpdatedCallback) {
                if (_this.log) {
                    console.log("app.updated received");
                    console.log(eventData.Body);
                }
                _this.AppUpdatedCallback(data);
            }
        });
        this.proxy.on("appstore.configuration.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.AppStoreConfigCreatedCallback) {
                if (_this.log) {
                    console.log("appstore.configuration.created received");
                    console.log(eventData.Body);
                }
                _this.AppStoreConfigCreatedCallback(data);
            }
        });
        this.proxy.on("appstore.configuration.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.AppStoreConfigUpdatedCallback) {
                if (_this.log) {
                    console.log("appstore.configuration.updated received");
                    console.log(eventData.Body);
                }
                _this.AppStoreConfigUpdatedCallback(data);
            }
        });
        this.proxy.on("appstore.configuration.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.AppStoreConfigDeletedCallback) {
                if (_this.log) {
                    console.log("appstore.configuration.deleted received");
                    console.log(eventData.Body);
                }
                _this.AppStoreConfigDeletedCallback(data);
            }
        });
    }
    AppHub.prototype.OnAppCreated = function (callback) {
        if (this.log) {
            console.log("app.created subscribed");
        }
        this.AppCreatedCallback = callback;
    };
    AppHub.prototype.OffAppCreated = function (callback) {
        if (this.log) {
            console.log("app.created unsubscribed");
        }
        this.AppCreatedCallback = undefined;
    };
    AppHub.prototype.OnAppUpdated = function (callback) {
        if (this.log) {
            console.log("app.updated subscribed");
        }
        this.AppUpdatedCallback = callback;
    };
    AppHub.prototype.OffAppUpdated = function (callback) {
        if (this.log) {
            console.log("app.updated unsubscribed");
        }
        this.AppUpdatedCallback = undefined;
    };
    AppHub.prototype.OnAppStoreConfigCreated = function (callback) {
        if (this.log) {
            console.log("appstore.configuration.created subscribed");
        }
        this.AppStoreConfigCreatedCallback = callback;
    };
    AppHub.prototype.OffAppStoreConfigCreated = function (callback) {
        if (this.log) {
            console.log("appstore.configuration.created unsubscribed");
        }
        this.AppStoreConfigCreatedCallback = undefined;
    };
    AppHub.prototype.OnAppStoreConfigUpdated = function (callback) {
        if (this.log) {
            console.log("appstore.configuration.updated subscribed");
        }
        this.AppStoreConfigUpdatedCallback = callback;
    };
    AppHub.prototype.OffAppStoreConfigUpdated = function (callback) {
        if (this.log) {
            console.log("appstore.configuration.updated unsubscribed");
        }
        this.AppStoreConfigUpdatedCallback = undefined;
    };
    AppHub.prototype.OnAppStoreConfigDeleted = function (callback) {
        if (this.log) {
            console.log("appstore.configuration.deleted subscribed");
        }
        this.AppStoreConfigDeletedCallback = callback;
    };
    AppHub.prototype.OffAppStoreConfigDeleted = function (callback) {
        if (this.log) {
            console.log("appstore.configuration.deleted unsubscribed");
        }
        this.AppStoreConfigDeletedCallback = undefined;
    };
    return AppHub;
}());
exports.AppHub = AppHub;
var BankAccountHub = (function () {
    function BankAccountHub(proxy, log) {
        var _this = this;
        this.BankAccountCreatedCallback = undefined;
        this.BankAccountUpdatedCallback = undefined;
        this.BankAccountDeletedCallback = undefined;
        this.BankAccountAssignedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("bankaccount.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.BankAccountCreatedCallback) {
                if (_this.log) {
                    console.log("bankaccount.created received");
                    console.log(eventData.Body);
                }
                _this.BankAccountCreatedCallback(data);
            }
        });
        this.proxy.on("bankaccount.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.BankAccountUpdatedCallback) {
                if (_this.log) {
                    console.log("bankaccount.updated received");
                    console.log(eventData.Body);
                }
                _this.BankAccountUpdatedCallback(data);
            }
        });
        this.proxy.on("bankaccount.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.BankAccountDeletedCallback) {
                if (_this.log) {
                    console.log("bankaccount.deleted received");
                    console.log(eventData.Body);
                }
                _this.BankAccountDeletedCallback(data);
            }
        });
        this.proxy.on("bankaccount.assigned", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.BankAccountAssignedCallback) {
                if (_this.log) {
                    console.log("bankaccount.assigned received");
                    console.log(eventData.Body);
                }
                _this.BankAccountAssignedCallback(data);
            }
        });
    }
    BankAccountHub.prototype.OnBankAccountCreated = function (callback) {
        if (this.log) {
            console.log("bankaccount.created subscribed");
        }
        this.BankAccountCreatedCallback = callback;
    };
    BankAccountHub.prototype.OffBankAccountCreated = function (callback) {
        if (this.log) {
            console.log("bankaccount.created unsubscribed");
        }
        this.BankAccountCreatedCallback = undefined;
    };
    BankAccountHub.prototype.OnBankAccountUpdated = function (callback) {
        if (this.log) {
            console.log("bankaccount.updated subscribed");
        }
        this.BankAccountUpdatedCallback = callback;
    };
    BankAccountHub.prototype.OffBankAccountUpdated = function (callback) {
        if (this.log) {
            console.log("bankaccount.updated unsubscribed");
        }
        this.BankAccountUpdatedCallback = undefined;
    };
    BankAccountHub.prototype.OnBankAccountDeleted = function (callback) {
        if (this.log) {
            console.log("bankaccount.deleted subscribed");
        }
        this.BankAccountDeletedCallback = callback;
    };
    BankAccountHub.prototype.OffBankAccountDeleted = function (callback) {
        if (this.log) {
            console.log("bankaccount.deleted unsubscribed");
        }
        this.BankAccountDeletedCallback = undefined;
    };
    BankAccountHub.prototype.OnBankAccountAssigned = function (callback) {
        if (this.log) {
            console.log("bankaccount.assigned subscribed");
        }
        this.BankAccountAssignedCallback = callback;
    };
    BankAccountHub.prototype.OffBankAccountAssigned = function (callback) {
        if (this.log) {
            console.log("bankaccount.assigned unsubscribed");
        }
        this.BankAccountAssignedCallback = undefined;
    };
    return BankAccountHub;
}());
exports.BankAccountHub = BankAccountHub;
var CampaignHub = (function () {
    function CampaignHub(proxy, log) {
        var _this = this;
        this.LoyaltyCampaignCreatedCallback = undefined;
        this.LoyaltyCampaignDeletedCallback = undefined;
        this.LoyaltyCampaignUpdatedCallback = undefined;
        this.RetentionCampaignCreatedCallback = undefined;
        this.RetentionCampaignDeletedCallback = undefined;
        this.RetentionCampaignUpdatedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("campaign.loyalty.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.LoyaltyCampaignCreatedCallback) {
                if (_this.log) {
                    console.log("campaign.loyalty.created received");
                    console.log(eventData.Body);
                }
                _this.LoyaltyCampaignCreatedCallback(data);
            }
        });
        this.proxy.on("campaign.loyalty.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.LoyaltyCampaignDeletedCallback) {
                if (_this.log) {
                    console.log("campaign.loyalty.deleted received");
                    console.log(eventData.Body);
                }
                _this.LoyaltyCampaignDeletedCallback(data);
            }
        });
        this.proxy.on("campaign.loyalty.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.LoyaltyCampaignUpdatedCallback) {
                if (_this.log) {
                    console.log("campaign.loyalty.updated received");
                    console.log(eventData.Body);
                }
                _this.LoyaltyCampaignUpdatedCallback(data);
            }
        });
        this.proxy.on("campaign.retention.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.RetentionCampaignCreatedCallback) {
                if (_this.log) {
                    console.log("campaign.retention.created received");
                    console.log(eventData.Body);
                }
                _this.RetentionCampaignCreatedCallback(data);
            }
        });
        this.proxy.on("campaign.retention.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.RetentionCampaignDeletedCallback) {
                if (_this.log) {
                    console.log("campaign.retention.deleted received");
                    console.log(eventData.Body);
                }
                _this.RetentionCampaignDeletedCallback(data);
            }
        });
        this.proxy.on("campaign.retention.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.RetentionCampaignUpdatedCallback) {
                if (_this.log) {
                    console.log("campaign.retention.updated received");
                    console.log(eventData.Body);
                }
                _this.RetentionCampaignUpdatedCallback(data);
            }
        });
    }
    CampaignHub.prototype.OnLoyaltyCampaignCreated = function (callback) {
        if (this.log) {
            console.log("campaign.loyalty.created subscribed");
        }
        this.LoyaltyCampaignCreatedCallback = callback;
    };
    CampaignHub.prototype.OffLoyaltyCampaignCreated = function (callback) {
        if (this.log) {
            console.log("campaign.loyalty.created unsubscribed");
        }
        this.LoyaltyCampaignCreatedCallback = undefined;
    };
    CampaignHub.prototype.OnLoyaltyCampaignDeleted = function (callback) {
        if (this.log) {
            console.log("campaign.loyalty.deleted subscribed");
        }
        this.LoyaltyCampaignDeletedCallback = callback;
    };
    CampaignHub.prototype.OffLoyaltyCampaignDeleted = function (callback) {
        if (this.log) {
            console.log("campaign.loyalty.deleted unsubscribed");
        }
        this.LoyaltyCampaignDeletedCallback = undefined;
    };
    CampaignHub.prototype.OnLoyaltyCampaignUpdated = function (callback) {
        if (this.log) {
            console.log("campaign.loyalty.updated subscribed");
        }
        this.LoyaltyCampaignUpdatedCallback = callback;
    };
    CampaignHub.prototype.OffLoyaltyCampaignUpdated = function (callback) {
        if (this.log) {
            console.log("campaign.loyalty.updated unsubscribed");
        }
        this.LoyaltyCampaignUpdatedCallback = undefined;
    };
    CampaignHub.prototype.OnRetentionCampaignCreated = function (callback) {
        if (this.log) {
            console.log("campaign.retention.created subscribed");
        }
        this.RetentionCampaignCreatedCallback = callback;
    };
    CampaignHub.prototype.OffRetentionCampaignCreated = function (callback) {
        if (this.log) {
            console.log("campaign.retention.created unsubscribed");
        }
        this.RetentionCampaignCreatedCallback = undefined;
    };
    CampaignHub.prototype.OnRetentionCampaignDeleted = function (callback) {
        if (this.log) {
            console.log("campaign.retention.deleted subscribed");
        }
        this.RetentionCampaignDeletedCallback = callback;
    };
    CampaignHub.prototype.OffRetentionCampaignDeleted = function (callback) {
        if (this.log) {
            console.log("campaign.retention.deleted unsubscribed");
        }
        this.RetentionCampaignDeletedCallback = undefined;
    };
    CampaignHub.prototype.OnRetentionCampaignUpdated = function (callback) {
        if (this.log) {
            console.log("campaign.retention.updated subscribed");
        }
        this.RetentionCampaignUpdatedCallback = callback;
    };
    CampaignHub.prototype.OffRetentionCampaignUpdated = function (callback) {
        if (this.log) {
            console.log("campaign.retention.updated unsubscribed");
        }
        this.RetentionCampaignUpdatedCallback = undefined;
    };
    return CampaignHub;
}());
exports.CampaignHub = CampaignHub;
var CardReaderHub = (function () {
    function CardReaderHub(proxy, log) {
        var _this = this;
        this.KioskBluetoothPairingModeCallback = undefined;
        this.KioskBluetoothTerminalUnpairedCallback = undefined;
        this.KioskBluetoothTerminalUpdatedCallback = undefined;
        this.KioskBluetoothTerminalInitiateUpdateCheckCallback = undefined;
        this.KioskBluetoothInstallUpdateInitiateCallback = undefined;
        this.KioskBluetoothTerminalCancelUpdateCallback = undefined;
        this.KioskBluetoothTerminalInstallationStatusCallback = undefined;
        this.KioskBluetoothTerminalFirmwareVersionStatusCallback = undefined;
        this.KioskTerminalActionStateChangedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("cardreaders.kiosk.bluetooth.initiatepairingmode", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.KioskBluetoothPairingModeCallback) {
                if (_this.log) {
                    console.log("cardreaders.kiosk.bluetooth.initiatepairingmode received");
                    console.log(eventData.Body);
                }
                _this.KioskBluetoothPairingModeCallback(data);
            }
        });
        this.proxy.on("cardreaders.kiosk.bluetooth.unpaired", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.KioskBluetoothTerminalUnpairedCallback) {
                if (_this.log) {
                    console.log("cardreaders.kiosk.bluetooth.unpaired received");
                    console.log(eventData.Body);
                }
                _this.KioskBluetoothTerminalUnpairedCallback(data);
            }
        });
        this.proxy.on("cardreaders.kiosk.bluetooth.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.KioskBluetoothTerminalUpdatedCallback) {
                if (_this.log) {
                    console.log("cardreaders.kiosk.bluetooth.updated received");
                    console.log(eventData.Body);
                }
                _this.KioskBluetoothTerminalUpdatedCallback(data);
            }
        });
        this.proxy.on("cardreaders.kiosk.bluetooth.checkforupdates", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.KioskBluetoothTerminalInitiateUpdateCheckCallback) {
                if (_this.log) {
                    console.log("cardreaders.kiosk.bluetooth.checkforupdates received");
                    console.log(eventData.Body);
                }
                _this.KioskBluetoothTerminalInitiateUpdateCheckCallback(data);
            }
        });
        this.proxy.on("cardreaders.kiosk.bluetooth.initiateinstallupdatemode", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.KioskBluetoothInstallUpdateInitiateCallback) {
                if (_this.log) {
                    console.log("cardreaders.kiosk.bluetooth.initiateinstallupdatemode received");
                    console.log(eventData.Body);
                }
                _this.KioskBluetoothInstallUpdateInitiateCallback(data);
            }
        });
        this.proxy.on("cardreaders.kiosk.bluetooth.cancelupdateinstall", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.KioskBluetoothTerminalCancelUpdateCallback) {
                if (_this.log) {
                    console.log("cardreaders.kiosk.bluetooth.cancelupdateinstall received");
                    console.log(eventData.Body);
                }
                _this.KioskBluetoothTerminalCancelUpdateCallback(data);
            }
        });
        this.proxy.on("cardreaders.kiosk.bluetooth.installationstatus", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.KioskBluetoothTerminalInstallationStatusCallback) {
                if (_this.log) {
                    console.log("cardreaders.kiosk.bluetooth.installationstatus received");
                    console.log(eventData.Body);
                }
                _this.KioskBluetoothTerminalInstallationStatusCallback(data);
            }
        });
        this.proxy.on("cardreaders.kiosk.bluetooth.firmwareupdateversion", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.KioskBluetoothTerminalFirmwareVersionStatusCallback) {
                if (_this.log) {
                    console.log("cardreaders.kiosk.bluetooth.firmwareupdateversion received");
                    console.log(eventData.Body);
                }
                _this.KioskBluetoothTerminalFirmwareVersionStatusCallback(data);
            }
        });
        this.proxy.on("cardreaders.kiosk.bluetooth.terminalactionstatechanged", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.KioskTerminalActionStateChangedCallback) {
                if (_this.log) {
                    console.log("cardreaders.kiosk.bluetooth.terminalactionstatechanged received");
                    console.log(eventData.Body);
                }
                _this.KioskTerminalActionStateChangedCallback(data);
            }
        });
    }
    CardReaderHub.prototype.OnKioskBluetoothPairingMode = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.initiatepairingmode subscribed");
        }
        this.KioskBluetoothPairingModeCallback = callback;
    };
    CardReaderHub.prototype.OffKioskBluetoothPairingMode = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.initiatepairingmode unsubscribed");
        }
        this.KioskBluetoothPairingModeCallback = undefined;
    };
    CardReaderHub.prototype.OnKioskBluetoothTerminalUnpaired = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.unpaired subscribed");
        }
        this.KioskBluetoothTerminalUnpairedCallback = callback;
    };
    CardReaderHub.prototype.OffKioskBluetoothTerminalUnpaired = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.unpaired unsubscribed");
        }
        this.KioskBluetoothTerminalUnpairedCallback = undefined;
    };
    CardReaderHub.prototype.OnKioskBluetoothTerminalUpdated = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.updated subscribed");
        }
        this.KioskBluetoothTerminalUpdatedCallback = callback;
    };
    CardReaderHub.prototype.OffKioskBluetoothTerminalUpdated = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.updated unsubscribed");
        }
        this.KioskBluetoothTerminalUpdatedCallback = undefined;
    };
    CardReaderHub.prototype.OnKioskBluetoothTerminalInitiateUpdateCheck = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.checkforupdates subscribed");
        }
        this.KioskBluetoothTerminalInitiateUpdateCheckCallback = callback;
    };
    CardReaderHub.prototype.OffKioskBluetoothTerminalInitiateUpdateCheck = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.checkforupdates unsubscribed");
        }
        this.KioskBluetoothTerminalInitiateUpdateCheckCallback = undefined;
    };
    CardReaderHub.prototype.OnKioskBluetoothInstallUpdateInitiate = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.initiateinstallupdatemode subscribed");
        }
        this.KioskBluetoothInstallUpdateInitiateCallback = callback;
    };
    CardReaderHub.prototype.OffKioskBluetoothInstallUpdateInitiate = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.initiateinstallupdatemode unsubscribed");
        }
        this.KioskBluetoothInstallUpdateInitiateCallback = undefined;
    };
    CardReaderHub.prototype.OnKioskBluetoothTerminalCancelUpdate = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.cancelupdateinstall subscribed");
        }
        this.KioskBluetoothTerminalCancelUpdateCallback = callback;
    };
    CardReaderHub.prototype.OffKioskBluetoothTerminalCancelUpdate = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.cancelupdateinstall unsubscribed");
        }
        this.KioskBluetoothTerminalCancelUpdateCallback = undefined;
    };
    CardReaderHub.prototype.OnKioskBluetoothTerminalInstallationStatus = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.installationstatus subscribed");
        }
        this.KioskBluetoothTerminalInstallationStatusCallback = callback;
    };
    CardReaderHub.prototype.OffKioskBluetoothTerminalInstallationStatus = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.installationstatus unsubscribed");
        }
        this.KioskBluetoothTerminalInstallationStatusCallback = undefined;
    };
    CardReaderHub.prototype.OnKioskBluetoothTerminalFirmwareVersionStatus = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.firmwareupdateversion subscribed");
        }
        this.KioskBluetoothTerminalFirmwareVersionStatusCallback = callback;
    };
    CardReaderHub.prototype.OffKioskBluetoothTerminalFirmwareVersionStatus = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.firmwareupdateversion unsubscribed");
        }
        this.KioskBluetoothTerminalFirmwareVersionStatusCallback = undefined;
    };
    CardReaderHub.prototype.OnKioskTerminalActionStateChanged = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.terminalactionstatechanged subscribed");
        }
        this.KioskTerminalActionStateChangedCallback = callback;
    };
    CardReaderHub.prototype.OffKioskTerminalActionStateChanged = function (callback) {
        if (this.log) {
            console.log("cardreaders.kiosk.bluetooth.terminalactionstatechanged unsubscribed");
        }
        this.KioskTerminalActionStateChangedCallback = undefined;
    };
    return CardReaderHub;
}());
exports.CardReaderHub = CardReaderHub;
var CustomerHub = (function () {
    function CustomerHub(proxy, log) {
        var _this = this;
        this.CustomerCreatedCallback = undefined;
        this.CustomerUpdatedCallback = undefined;
        this.CustomerConsentUpdatedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("customer.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.CustomerCreatedCallback) {
                if (_this.log) {
                    console.log("customer.created received");
                    console.log(eventData.Body);
                }
                _this.CustomerCreatedCallback(data);
            }
        });
        this.proxy.on("customer.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.CustomerUpdatedCallback) {
                if (_this.log) {
                    console.log("customer.updated received");
                    console.log(eventData.Body);
                }
                _this.CustomerUpdatedCallback(data);
            }
        });
        this.proxy.on("customer.consent.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.CustomerConsentUpdatedCallback) {
                if (_this.log) {
                    console.log("customer.consent.updated received");
                    console.log(eventData.Body);
                }
                _this.CustomerConsentUpdatedCallback(data);
            }
        });
    }
    CustomerHub.prototype.OnCustomerCreated = function (callback) {
        if (this.log) {
            console.log("customer.created subscribed");
        }
        this.CustomerCreatedCallback = callback;
    };
    CustomerHub.prototype.OffCustomerCreated = function (callback) {
        if (this.log) {
            console.log("customer.created unsubscribed");
        }
        this.CustomerCreatedCallback = undefined;
    };
    CustomerHub.prototype.OnCustomerUpdated = function (callback) {
        if (this.log) {
            console.log("customer.updated subscribed");
        }
        this.CustomerUpdatedCallback = callback;
    };
    CustomerHub.prototype.OffCustomerUpdated = function (callback) {
        if (this.log) {
            console.log("customer.updated unsubscribed");
        }
        this.CustomerUpdatedCallback = undefined;
    };
    CustomerHub.prototype.OnCustomerConsentUpdated = function (callback) {
        if (this.log) {
            console.log("customer.consent.updated subscribed");
        }
        this.CustomerConsentUpdatedCallback = callback;
    };
    CustomerHub.prototype.OffCustomerConsentUpdated = function (callback) {
        if (this.log) {
            console.log("customer.consent.updated unsubscribed");
        }
        this.CustomerConsentUpdatedCallback = undefined;
    };
    return CustomerHub;
}());
exports.CustomerHub = CustomerHub;
var HydraHub = (function () {
    function HydraHub(proxy, log) {
        var _this = this;
        this.HydraAssignedCallback = undefined;
        this.HydraRequestResetCallback = undefined;
        this.HydraSettingChangedCallback = undefined;
        this.HydraConnectionStatusChangedCallback = undefined;
        this.HydraUnAssignedCallback = undefined;
        this.HydraStoreAssignedCallback = undefined;
        this.HydraStoreUnassignedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("hydra.assigned", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.HydraAssignedCallback) {
                if (_this.log) {
                    console.log("hydra.assigned received");
                    console.log(eventData.Body);
                }
                _this.HydraAssignedCallback(data);
            }
        });
        this.proxy.on("hydra.request_reset", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.HydraRequestResetCallback) {
                if (_this.log) {
                    console.log("hydra.request_reset received");
                    console.log(eventData.Body);
                }
                _this.HydraRequestResetCallback(data);
            }
        });
        this.proxy.on("hydra.setting_changed", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.HydraSettingChangedCallback) {
                if (_this.log) {
                    console.log("hydra.setting_changed received");
                    console.log(eventData.Body);
                }
                _this.HydraSettingChangedCallback(data);
            }
        });
        this.proxy.on("hydra.conection_status_changed", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.HydraConnectionStatusChangedCallback) {
                if (_this.log) {
                    console.log("hydra.conection_status_changed received");
                    console.log(eventData.Body);
                }
                _this.HydraConnectionStatusChangedCallback(data);
            }
        });
        this.proxy.on("hydra.unassigned", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.HydraUnAssignedCallback) {
                if (_this.log) {
                    console.log("hydra.unassigned received");
                    console.log(eventData.Body);
                }
                _this.HydraUnAssignedCallback(data);
            }
        });
        this.proxy.on("hydra.store.assigned", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.HydraStoreAssignedCallback) {
                if (_this.log) {
                    console.log("hydra.store.assigned received");
                    console.log(eventData.Body);
                }
                _this.HydraStoreAssignedCallback(data);
            }
        });
        this.proxy.on("hydra.store.unassigned", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.HydraStoreUnassignedCallback) {
                if (_this.log) {
                    console.log("hydra.store.unassigned received");
                    console.log(eventData.Body);
                }
                _this.HydraStoreUnassignedCallback(data);
            }
        });
    }
    HydraHub.prototype.OnHydraAssigned = function (callback) {
        if (this.log) {
            console.log("hydra.assigned subscribed");
        }
        this.HydraAssignedCallback = callback;
    };
    HydraHub.prototype.OffHydraAssigned = function (callback) {
        if (this.log) {
            console.log("hydra.assigned unsubscribed");
        }
        this.HydraAssignedCallback = undefined;
    };
    HydraHub.prototype.OnHydraRequestReset = function (callback) {
        if (this.log) {
            console.log("hydra.request_reset subscribed");
        }
        this.HydraRequestResetCallback = callback;
    };
    HydraHub.prototype.OffHydraRequestReset = function (callback) {
        if (this.log) {
            console.log("hydra.request_reset unsubscribed");
        }
        this.HydraRequestResetCallback = undefined;
    };
    HydraHub.prototype.OnHydraSettingChanged = function (callback) {
        if (this.log) {
            console.log("hydra.setting_changed subscribed");
        }
        this.HydraSettingChangedCallback = callback;
    };
    HydraHub.prototype.OffHydraSettingChanged = function (callback) {
        if (this.log) {
            console.log("hydra.setting_changed unsubscribed");
        }
        this.HydraSettingChangedCallback = undefined;
    };
    HydraHub.prototype.OnHydraConnectionStatusChanged = function (callback) {
        if (this.log) {
            console.log("hydra.conection_status_changed subscribed");
        }
        this.HydraConnectionStatusChangedCallback = callback;
    };
    HydraHub.prototype.OffHydraConnectionStatusChanged = function (callback) {
        if (this.log) {
            console.log("hydra.conection_status_changed unsubscribed");
        }
        this.HydraConnectionStatusChangedCallback = undefined;
    };
    HydraHub.prototype.OnHydraUnAssigned = function (callback) {
        if (this.log) {
            console.log("hydra.unassigned subscribed");
        }
        this.HydraUnAssignedCallback = callback;
    };
    HydraHub.prototype.OffHydraUnAssigned = function (callback) {
        if (this.log) {
            console.log("hydra.unassigned unsubscribed");
        }
        this.HydraUnAssignedCallback = undefined;
    };
    HydraHub.prototype.OnHydraStoreAssigned = function (callback) {
        if (this.log) {
            console.log("hydra.store.assigned subscribed");
        }
        this.HydraStoreAssignedCallback = callback;
    };
    HydraHub.prototype.OffHydraStoreAssigned = function (callback) {
        if (this.log) {
            console.log("hydra.store.assigned unsubscribed");
        }
        this.HydraStoreAssignedCallback = undefined;
    };
    HydraHub.prototype.OnHydraStoreUnassigned = function (callback) {
        if (this.log) {
            console.log("hydra.store.unassigned subscribed");
        }
        this.HydraStoreUnassignedCallback = callback;
    };
    HydraHub.prototype.OffHydraStoreUnassigned = function (callback) {
        if (this.log) {
            console.log("hydra.store.unassigned unsubscribed");
        }
        this.HydraStoreUnassignedCallback = undefined;
    };
    return HydraHub;
}());
exports.HydraHub = HydraHub;
var MenuCheckpointHub = (function () {
    function MenuCheckpointHub(proxy, log) {
        var _this = this;
        this.MenuCheckpointCreatedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("menu_checkpoint.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuCheckpointCreatedCallback) {
                if (_this.log) {
                    console.log("menu_checkpoint.created received");
                    console.log(eventData.Body);
                }
                _this.MenuCheckpointCreatedCallback(data);
            }
        });
    }
    MenuCheckpointHub.prototype.OnMenuCheckpointCreated = function (callback) {
        if (this.log) {
            console.log("menu_checkpoint.created subscribed");
        }
        this.MenuCheckpointCreatedCallback = callback;
    };
    MenuCheckpointHub.prototype.OffMenuCheckpointCreated = function (callback) {
        if (this.log) {
            console.log("menu_checkpoint.created unsubscribed");
        }
        this.MenuCheckpointCreatedCallback = undefined;
    };
    return MenuCheckpointHub;
}());
exports.MenuCheckpointHub = MenuCheckpointHub;
var MenuHub = (function () {
    function MenuHub(proxy, log) {
        var _this = this;
        this.MenuCreatedCallback = undefined;
        this.MenuUpdatedCallback = undefined;
        this.MenuUploadedCallback = undefined;
        this.MenuBulkEditCallback = undefined;
        this.MenuSectionCreatedCallback = undefined;
        this.MenuSectionUpdatedCallback = undefined;
        this.MenuSectionDeletedCallback = undefined;
        this.MenuSectionItemCreatedCallback = undefined;
        this.MenuSectionItemUpdatedCallback = undefined;
        this.MenuSectionItemDeletedCallback = undefined;
        this.MenuItemOptionSetCreatedCallback = undefined;
        this.MenuItemOptionSetUpdatedCallback = undefined;
        this.MenuItemOptionSetDeletedCallback = undefined;
        this.MenuItemOptionSetItemCreatedCallback = undefined;
        this.MenuItemOptionSetItemUpdatedCallback = undefined;
        this.MenuItemOptionSetItemDeletedCallback = undefined;
        this.MenuCheckpointCreatedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("menu.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuCreatedCallback) {
                if (_this.log) {
                    console.log("menu.created received");
                    console.log(eventData.Body);
                }
                _this.MenuCreatedCallback(data);
            }
        });
        this.proxy.on("menu.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuUpdatedCallback) {
                if (_this.log) {
                    console.log("menu.updated received");
                    console.log(eventData.Body);
                }
                _this.MenuUpdatedCallback(data);
            }
        });
        this.proxy.on("menu.uploaded", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuUploadedCallback) {
                if (_this.log) {
                    console.log("menu.uploaded received");
                    console.log(eventData.Body);
                }
                _this.MenuUploadedCallback(data);
            }
        });
        this.proxy.on("menu.bulk.edit", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuBulkEditCallback) {
                if (_this.log) {
                    console.log("menu.bulk.edit received");
                    console.log(eventData.Body);
                }
                _this.MenuBulkEditCallback(data);
            }
        });
        this.proxy.on("menu.section.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuSectionCreatedCallback) {
                if (_this.log) {
                    console.log("menu.section.created received");
                    console.log(eventData.Body);
                }
                _this.MenuSectionCreatedCallback(data);
            }
        });
        this.proxy.on("menu.section.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuSectionUpdatedCallback) {
                if (_this.log) {
                    console.log("menu.section.updated received");
                    console.log(eventData.Body);
                }
                _this.MenuSectionUpdatedCallback(data);
            }
        });
        this.proxy.on("menu.section.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuSectionDeletedCallback) {
                if (_this.log) {
                    console.log("menu.section.deleted received");
                    console.log(eventData.Body);
                }
                _this.MenuSectionDeletedCallback(data);
            }
        });
        this.proxy.on("menu.section_item.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuSectionItemCreatedCallback) {
                if (_this.log) {
                    console.log("menu.section_item.created received");
                    console.log(eventData.Body);
                }
                _this.MenuSectionItemCreatedCallback(data);
            }
        });
        this.proxy.on("menu.section_item.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuSectionItemUpdatedCallback) {
                if (_this.log) {
                    console.log("menu.section_item.updated received");
                    console.log(eventData.Body);
                }
                _this.MenuSectionItemUpdatedCallback(data);
            }
        });
        this.proxy.on("menu.section_item.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuSectionItemDeletedCallback) {
                if (_this.log) {
                    console.log("menu.section_item.deleted received");
                    console.log(eventData.Body);
                }
                _this.MenuSectionItemDeletedCallback(data);
            }
        });
        this.proxy.on("menu.option_set.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuItemOptionSetCreatedCallback) {
                if (_this.log) {
                    console.log("menu.option_set.created received");
                    console.log(eventData.Body);
                }
                _this.MenuItemOptionSetCreatedCallback(data);
            }
        });
        this.proxy.on("menu.option_set.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuItemOptionSetUpdatedCallback) {
                if (_this.log) {
                    console.log("menu.option_set.updated received");
                    console.log(eventData.Body);
                }
                _this.MenuItemOptionSetUpdatedCallback(data);
            }
        });
        this.proxy.on("menu.option_set.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuItemOptionSetDeletedCallback) {
                if (_this.log) {
                    console.log("menu.option_set.deleted received");
                    console.log(eventData.Body);
                }
                _this.MenuItemOptionSetDeletedCallback(data);
            }
        });
        this.proxy.on("menu.option_set_item.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuItemOptionSetItemCreatedCallback) {
                if (_this.log) {
                    console.log("menu.option_set_item.created received");
                    console.log(eventData.Body);
                }
                _this.MenuItemOptionSetItemCreatedCallback(data);
            }
        });
        this.proxy.on("menu.option_set_item.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuItemOptionSetItemUpdatedCallback) {
                if (_this.log) {
                    console.log("menu.option_set_item.updated received");
                    console.log(eventData.Body);
                }
                _this.MenuItemOptionSetItemUpdatedCallback(data);
            }
        });
        this.proxy.on("menu.option_set_item.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuItemOptionSetItemDeletedCallback) {
                if (_this.log) {
                    console.log("menu.option_set_item.deleted received");
                    console.log(eventData.Body);
                }
                _this.MenuItemOptionSetItemDeletedCallback(data);
            }
        });
        this.proxy.on("menu_checkpoint.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.MenuCheckpointCreatedCallback) {
                if (_this.log) {
                    console.log("menu_checkpoint.created received");
                    console.log(eventData.Body);
                }
                _this.MenuCheckpointCreatedCallback(data);
            }
        });
    }
    MenuHub.prototype.OnMenuCreated = function (callback) {
        if (this.log) {
            console.log("menu.created subscribed");
        }
        this.MenuCreatedCallback = callback;
    };
    MenuHub.prototype.OffMenuCreated = function (callback) {
        if (this.log) {
            console.log("menu.created unsubscribed");
        }
        this.MenuCreatedCallback = undefined;
    };
    MenuHub.prototype.OnMenuUpdated = function (callback) {
        if (this.log) {
            console.log("menu.updated subscribed");
        }
        this.MenuUpdatedCallback = callback;
    };
    MenuHub.prototype.OffMenuUpdated = function (callback) {
        if (this.log) {
            console.log("menu.updated unsubscribed");
        }
        this.MenuUpdatedCallback = undefined;
    };
    MenuHub.prototype.OnMenuUploaded = function (callback) {
        if (this.log) {
            console.log("menu.uploaded subscribed");
        }
        this.MenuUploadedCallback = callback;
    };
    MenuHub.prototype.OffMenuUploaded = function (callback) {
        if (this.log) {
            console.log("menu.uploaded unsubscribed");
        }
        this.MenuUploadedCallback = undefined;
    };
    MenuHub.prototype.OnMenuBulkEdit = function (callback) {
        if (this.log) {
            console.log("menu.bulk.edit subscribed");
        }
        this.MenuBulkEditCallback = callback;
    };
    MenuHub.prototype.OffMenuBulkEdit = function (callback) {
        if (this.log) {
            console.log("menu.bulk.edit unsubscribed");
        }
        this.MenuBulkEditCallback = undefined;
    };
    MenuHub.prototype.OnMenuSectionCreated = function (callback) {
        if (this.log) {
            console.log("menu.section.created subscribed");
        }
        this.MenuSectionCreatedCallback = callback;
    };
    MenuHub.prototype.OffMenuSectionCreated = function (callback) {
        if (this.log) {
            console.log("menu.section.created unsubscribed");
        }
        this.MenuSectionCreatedCallback = undefined;
    };
    MenuHub.prototype.OnMenuSectionUpdated = function (callback) {
        if (this.log) {
            console.log("menu.section.updated subscribed");
        }
        this.MenuSectionUpdatedCallback = callback;
    };
    MenuHub.prototype.OffMenuSectionUpdated = function (callback) {
        if (this.log) {
            console.log("menu.section.updated unsubscribed");
        }
        this.MenuSectionUpdatedCallback = undefined;
    };
    MenuHub.prototype.OnMenuSectionDeleted = function (callback) {
        if (this.log) {
            console.log("menu.section.deleted subscribed");
        }
        this.MenuSectionDeletedCallback = callback;
    };
    MenuHub.prototype.OffMenuSectionDeleted = function (callback) {
        if (this.log) {
            console.log("menu.section.deleted unsubscribed");
        }
        this.MenuSectionDeletedCallback = undefined;
    };
    MenuHub.prototype.OnMenuSectionItemCreated = function (callback) {
        if (this.log) {
            console.log("menu.section_item.created subscribed");
        }
        this.MenuSectionItemCreatedCallback = callback;
    };
    MenuHub.prototype.OffMenuSectionItemCreated = function (callback) {
        if (this.log) {
            console.log("menu.section_item.created unsubscribed");
        }
        this.MenuSectionItemCreatedCallback = undefined;
    };
    MenuHub.prototype.OnMenuSectionItemUpdated = function (callback) {
        if (this.log) {
            console.log("menu.section_item.updated subscribed");
        }
        this.MenuSectionItemUpdatedCallback = callback;
    };
    MenuHub.prototype.OffMenuSectionItemUpdated = function (callback) {
        if (this.log) {
            console.log("menu.section_item.updated unsubscribed");
        }
        this.MenuSectionItemUpdatedCallback = undefined;
    };
    MenuHub.prototype.OnMenuSectionItemDeleted = function (callback) {
        if (this.log) {
            console.log("menu.section_item.deleted subscribed");
        }
        this.MenuSectionItemDeletedCallback = callback;
    };
    MenuHub.prototype.OffMenuSectionItemDeleted = function (callback) {
        if (this.log) {
            console.log("menu.section_item.deleted unsubscribed");
        }
        this.MenuSectionItemDeletedCallback = undefined;
    };
    MenuHub.prototype.OnMenuItemOptionSetCreated = function (callback) {
        if (this.log) {
            console.log("menu.option_set.created subscribed");
        }
        this.MenuItemOptionSetCreatedCallback = callback;
    };
    MenuHub.prototype.OffMenuItemOptionSetCreated = function (callback) {
        if (this.log) {
            console.log("menu.option_set.created unsubscribed");
        }
        this.MenuItemOptionSetCreatedCallback = undefined;
    };
    MenuHub.prototype.OnMenuItemOptionSetUpdated = function (callback) {
        if (this.log) {
            console.log("menu.option_set.updated subscribed");
        }
        this.MenuItemOptionSetUpdatedCallback = callback;
    };
    MenuHub.prototype.OffMenuItemOptionSetUpdated = function (callback) {
        if (this.log) {
            console.log("menu.option_set.updated unsubscribed");
        }
        this.MenuItemOptionSetUpdatedCallback = undefined;
    };
    MenuHub.prototype.OnMenuItemOptionSetDeleted = function (callback) {
        if (this.log) {
            console.log("menu.option_set.deleted subscribed");
        }
        this.MenuItemOptionSetDeletedCallback = callback;
    };
    MenuHub.prototype.OffMenuItemOptionSetDeleted = function (callback) {
        if (this.log) {
            console.log("menu.option_set.deleted unsubscribed");
        }
        this.MenuItemOptionSetDeletedCallback = undefined;
    };
    MenuHub.prototype.OnMenuItemOptionSetItemCreated = function (callback) {
        if (this.log) {
            console.log("menu.option_set_item.created subscribed");
        }
        this.MenuItemOptionSetItemCreatedCallback = callback;
    };
    MenuHub.prototype.OffMenuItemOptionSetItemCreated = function (callback) {
        if (this.log) {
            console.log("menu.option_set_item.created unsubscribed");
        }
        this.MenuItemOptionSetItemCreatedCallback = undefined;
    };
    MenuHub.prototype.OnMenuItemOptionSetItemUpdated = function (callback) {
        if (this.log) {
            console.log("menu.option_set_item.updated subscribed");
        }
        this.MenuItemOptionSetItemUpdatedCallback = callback;
    };
    MenuHub.prototype.OffMenuItemOptionSetItemUpdated = function (callback) {
        if (this.log) {
            console.log("menu.option_set_item.updated unsubscribed");
        }
        this.MenuItemOptionSetItemUpdatedCallback = undefined;
    };
    MenuHub.prototype.OnMenuItemOptionSetItemDeleted = function (callback) {
        if (this.log) {
            console.log("menu.option_set_item.deleted subscribed");
        }
        this.MenuItemOptionSetItemDeletedCallback = callback;
    };
    MenuHub.prototype.OffMenuItemOptionSetItemDeleted = function (callback) {
        if (this.log) {
            console.log("menu.option_set_item.deleted unsubscribed");
        }
        this.MenuItemOptionSetItemDeletedCallback = undefined;
    };
    MenuHub.prototype.OnMenuCheckpointCreated = function (callback) {
        if (this.log) {
            console.log("menu_checkpoint.created subscribed");
        }
        this.MenuCheckpointCreatedCallback = callback;
    };
    MenuHub.prototype.OffMenuCheckpointCreated = function (callback) {
        if (this.log) {
            console.log("menu_checkpoint.created unsubscribed");
        }
        this.MenuCheckpointCreatedCallback = undefined;
    };
    return MenuHub;
}());
exports.MenuHub = MenuHub;
var OrderHub = (function () {
    function OrderHub(proxy, log) {
        var _this = this;
        this.OrderCreatedCallback = undefined;
        this.OrderDispatchedCallback = undefined;
        this.OrderRejectedCallback = undefined;
        this.OrderAcceptedCallback = undefined;
        this.OrderRefundedCallback = undefined;
        this.OrderTipUpdatedCallback = undefined;
        this.OrderRatingUpdatedCallback = undefined;
        this.OrderDeliveryTrackingStatusUpdatedCallback = undefined;
        this.OrderBatchPublishedCallback = undefined;
        this.OrderFulfillmentStatusUpdatedCallback = undefined;
        this.OrderCapacityConfigUpdatedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("order.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.OrderCreatedCallback) {
                if (_this.log) {
                    console.log("order.created received");
                    console.log(eventData.Body);
                }
                _this.OrderCreatedCallback(data);
            }
        });
        this.proxy.on("order.dispatched", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.OrderDispatchedCallback) {
                if (_this.log) {
                    console.log("order.dispatched received");
                    console.log(eventData.Body);
                }
                _this.OrderDispatchedCallback(data);
            }
        });
        this.proxy.on("order.rejected", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.OrderRejectedCallback) {
                if (_this.log) {
                    console.log("order.rejected received");
                    console.log(eventData.Body);
                }
                _this.OrderRejectedCallback(data);
            }
        });
        this.proxy.on("order.accepted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.OrderAcceptedCallback) {
                if (_this.log) {
                    console.log("order.accepted received");
                    console.log(eventData.Body);
                }
                _this.OrderAcceptedCallback(data);
            }
        });
        this.proxy.on("order.refunded", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.OrderRefundedCallback) {
                if (_this.log) {
                    console.log("order.refunded received");
                    console.log(eventData.Body);
                }
                _this.OrderRefundedCallback(data);
            }
        });
        this.proxy.on("order.tip.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.OrderTipUpdatedCallback) {
                if (_this.log) {
                    console.log("order.tip.updated received");
                    console.log(eventData.Body);
                }
                _this.OrderTipUpdatedCallback(data);
            }
        });
        this.proxy.on("order.rating.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.OrderRatingUpdatedCallback) {
                if (_this.log) {
                    console.log("order.rating.updated received");
                    console.log(eventData.Body);
                }
                _this.OrderRatingUpdatedCallback(data);
            }
        });
        this.proxy.on("order.deliverytracking.status.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.OrderDeliveryTrackingStatusUpdatedCallback) {
                if (_this.log) {
                    console.log("order.deliverytracking.status.updated received");
                    console.log(eventData.Body);
                }
                _this.OrderDeliveryTrackingStatusUpdatedCallback(data);
            }
        });
        this.proxy.on("order.batch.published", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.OrderBatchPublishedCallback) {
                if (_this.log) {
                    console.log("order.batch.published received");
                    console.log(eventData.Body);
                }
                _this.OrderBatchPublishedCallback(data);
            }
        });
        this.proxy.on("order.fulfillment.status.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.OrderFulfillmentStatusUpdatedCallback) {
                if (_this.log) {
                    console.log("order.fulfillment.status.updated received");
                    console.log(eventData.Body);
                }
                _this.OrderFulfillmentStatusUpdatedCallback(data);
            }
        });
        this.proxy.on("order.capacity.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.OrderCapacityConfigUpdatedCallback) {
                if (_this.log) {
                    console.log("order.capacity.updated received");
                    console.log(eventData.Body);
                }
                _this.OrderCapacityConfigUpdatedCallback(data);
            }
        });
    }
    OrderHub.prototype.OnOrderCreated = function (callback) {
        if (this.log) {
            console.log("order.created subscribed");
        }
        this.OrderCreatedCallback = callback;
    };
    OrderHub.prototype.OffOrderCreated = function (callback) {
        if (this.log) {
            console.log("order.created unsubscribed");
        }
        this.OrderCreatedCallback = undefined;
    };
    OrderHub.prototype.OnOrderDispatched = function (callback) {
        if (this.log) {
            console.log("order.dispatched subscribed");
        }
        this.OrderDispatchedCallback = callback;
    };
    OrderHub.prototype.OffOrderDispatched = function (callback) {
        if (this.log) {
            console.log("order.dispatched unsubscribed");
        }
        this.OrderDispatchedCallback = undefined;
    };
    OrderHub.prototype.OnOrderRejected = function (callback) {
        if (this.log) {
            console.log("order.rejected subscribed");
        }
        this.OrderRejectedCallback = callback;
    };
    OrderHub.prototype.OffOrderRejected = function (callback) {
        if (this.log) {
            console.log("order.rejected unsubscribed");
        }
        this.OrderRejectedCallback = undefined;
    };
    OrderHub.prototype.OnOrderAccepted = function (callback) {
        if (this.log) {
            console.log("order.accepted subscribed");
        }
        this.OrderAcceptedCallback = callback;
    };
    OrderHub.prototype.OffOrderAccepted = function (callback) {
        if (this.log) {
            console.log("order.accepted unsubscribed");
        }
        this.OrderAcceptedCallback = undefined;
    };
    OrderHub.prototype.OnOrderRefunded = function (callback) {
        if (this.log) {
            console.log("order.refunded subscribed");
        }
        this.OrderRefundedCallback = callback;
    };
    OrderHub.prototype.OffOrderRefunded = function (callback) {
        if (this.log) {
            console.log("order.refunded unsubscribed");
        }
        this.OrderRefundedCallback = undefined;
    };
    OrderHub.prototype.OnOrderTipUpdated = function (callback) {
        if (this.log) {
            console.log("order.tip.updated subscribed");
        }
        this.OrderTipUpdatedCallback = callback;
    };
    OrderHub.prototype.OffOrderTipUpdated = function (callback) {
        if (this.log) {
            console.log("order.tip.updated unsubscribed");
        }
        this.OrderTipUpdatedCallback = undefined;
    };
    OrderHub.prototype.OnOrderRatingUpdated = function (callback) {
        if (this.log) {
            console.log("order.rating.updated subscribed");
        }
        this.OrderRatingUpdatedCallback = callback;
    };
    OrderHub.prototype.OffOrderRatingUpdated = function (callback) {
        if (this.log) {
            console.log("order.rating.updated unsubscribed");
        }
        this.OrderRatingUpdatedCallback = undefined;
    };
    OrderHub.prototype.OnOrderDeliveryTrackingStatusUpdated = function (callback) {
        if (this.log) {
            console.log("order.deliverytracking.status.updated subscribed");
        }
        this.OrderDeliveryTrackingStatusUpdatedCallback = callback;
    };
    OrderHub.prototype.OffOrderDeliveryTrackingStatusUpdated = function (callback) {
        if (this.log) {
            console.log("order.deliverytracking.status.updated unsubscribed");
        }
        this.OrderDeliveryTrackingStatusUpdatedCallback = undefined;
    };
    OrderHub.prototype.OnOrderBatchPublished = function (callback) {
        if (this.log) {
            console.log("order.batch.published subscribed");
        }
        this.OrderBatchPublishedCallback = callback;
    };
    OrderHub.prototype.OffOrderBatchPublished = function (callback) {
        if (this.log) {
            console.log("order.batch.published unsubscribed");
        }
        this.OrderBatchPublishedCallback = undefined;
    };
    OrderHub.prototype.OnOrderFulfillmentStatusUpdated = function (callback) {
        if (this.log) {
            console.log("order.fulfillment.status.updated subscribed");
        }
        this.OrderFulfillmentStatusUpdatedCallback = callback;
    };
    OrderHub.prototype.OffOrderFulfillmentStatusUpdated = function (callback) {
        if (this.log) {
            console.log("order.fulfillment.status.updated unsubscribed");
        }
        this.OrderFulfillmentStatusUpdatedCallback = undefined;
    };
    OrderHub.prototype.OnOrderCapacityConfigUpdated = function (callback) {
        if (this.log) {
            console.log("order.capacity.updated subscribed");
        }
        this.OrderCapacityConfigUpdatedCallback = callback;
    };
    OrderHub.prototype.OffOrderCapacityConfigUpdated = function (callback) {
        if (this.log) {
            console.log("order.capacity.updated unsubscribed");
        }
        this.OrderCapacityConfigUpdatedCallback = undefined;
    };
    return OrderHub;
}());
exports.OrderHub = OrderHub;
var PhoneCallHub = (function () {
    function PhoneCallHub(proxy, log) {
        var _this = this;
        this.PhoneCallStartedCallback = undefined;
        this.PhoneCallEndedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("phone_call.started", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.PhoneCallStartedCallback) {
                if (_this.log) {
                    console.log("phone_call.started received");
                    console.log(eventData.Body);
                }
                _this.PhoneCallStartedCallback(data);
            }
        });
        this.proxy.on("phone_call.ended", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.PhoneCallEndedCallback) {
                if (_this.log) {
                    console.log("phone_call.ended received");
                    console.log(eventData.Body);
                }
                _this.PhoneCallEndedCallback(data);
            }
        });
    }
    PhoneCallHub.prototype.OnPhoneCallStarted = function (callback) {
        if (this.log) {
            console.log("phone_call.started subscribed");
        }
        this.PhoneCallStartedCallback = callback;
    };
    PhoneCallHub.prototype.OffPhoneCallStarted = function (callback) {
        if (this.log) {
            console.log("phone_call.started unsubscribed");
        }
        this.PhoneCallStartedCallback = undefined;
    };
    PhoneCallHub.prototype.OnPhoneCallEnded = function (callback) {
        if (this.log) {
            console.log("phone_call.ended subscribed");
        }
        this.PhoneCallEndedCallback = callback;
    };
    PhoneCallHub.prototype.OffPhoneCallEnded = function (callback) {
        if (this.log) {
            console.log("phone_call.ended unsubscribed");
        }
        this.PhoneCallEndedCallback = undefined;
    };
    return PhoneCallHub;
}());
exports.PhoneCallHub = PhoneCallHub;
var PrinterHub = (function () {
    function PrinterHub(proxy, log) {
        var _this = this;
        this.PrinterTurnedOnCallback = undefined;
        this.PrinterTurnedOffCallback = undefined;
        this.PrinterAssignedToStoreCallback = undefined;
        this.PrinterUnassignedFromStoreCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("printer.turned_on", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.PrinterTurnedOnCallback) {
                if (_this.log) {
                    console.log("printer.turned_on received");
                    console.log(eventData.Body);
                }
                _this.PrinterTurnedOnCallback(data);
            }
        });
        this.proxy.on("printer.turned_off", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.PrinterTurnedOffCallback) {
                if (_this.log) {
                    console.log("printer.turned_off received");
                    console.log(eventData.Body);
                }
                _this.PrinterTurnedOffCallback(data);
            }
        });
        this.proxy.on("printer.assigned_to_store", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.PrinterAssignedToStoreCallback) {
                if (_this.log) {
                    console.log("printer.assigned_to_store received");
                    console.log(eventData.Body);
                }
                _this.PrinterAssignedToStoreCallback(data);
            }
        });
        this.proxy.on("printer.unassigned_from_store", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.PrinterUnassignedFromStoreCallback) {
                if (_this.log) {
                    console.log("printer.unassigned_from_store received");
                    console.log(eventData.Body);
                }
                _this.PrinterUnassignedFromStoreCallback(data);
            }
        });
    }
    PrinterHub.prototype.OnPrinterTurnedOn = function (callback) {
        if (this.log) {
            console.log("printer.turned_on subscribed");
        }
        this.PrinterTurnedOnCallback = callback;
    };
    PrinterHub.prototype.OffPrinterTurnedOn = function (callback) {
        if (this.log) {
            console.log("printer.turned_on unsubscribed");
        }
        this.PrinterTurnedOnCallback = undefined;
    };
    PrinterHub.prototype.OnPrinterTurnedOff = function (callback) {
        if (this.log) {
            console.log("printer.turned_off subscribed");
        }
        this.PrinterTurnedOffCallback = callback;
    };
    PrinterHub.prototype.OffPrinterTurnedOff = function (callback) {
        if (this.log) {
            console.log("printer.turned_off unsubscribed");
        }
        this.PrinterTurnedOffCallback = undefined;
    };
    PrinterHub.prototype.OnPrinterAssignedToStore = function (callback) {
        if (this.log) {
            console.log("printer.assigned_to_store subscribed");
        }
        this.PrinterAssignedToStoreCallback = callback;
    };
    PrinterHub.prototype.OffPrinterAssignedToStore = function (callback) {
        if (this.log) {
            console.log("printer.assigned_to_store unsubscribed");
        }
        this.PrinterAssignedToStoreCallback = undefined;
    };
    PrinterHub.prototype.OnPrinterUnassignedFromStore = function (callback) {
        if (this.log) {
            console.log("printer.unassigned_from_store subscribed");
        }
        this.PrinterUnassignedFromStoreCallback = callback;
    };
    PrinterHub.prototype.OffPrinterUnassignedFromStore = function (callback) {
        if (this.log) {
            console.log("printer.unassigned_from_store unsubscribed");
        }
        this.PrinterUnassignedFromStoreCallback = undefined;
    };
    return PrinterHub;
}());
exports.PrinterHub = PrinterHub;
var StoreGroupHub = (function () {
    function StoreGroupHub(proxy, log) {
        var _this = this;
        this.StoreGroupCreatedCallback = undefined;
        this.StoreGroupUpdatedCallback = undefined;
        this.StoreGroupDeletedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("store_group.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreGroupCreatedCallback) {
                if (_this.log) {
                    console.log("store_group.created received");
                    console.log(eventData.Body);
                }
                _this.StoreGroupCreatedCallback(data);
            }
        });
        this.proxy.on("store_group.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreGroupUpdatedCallback) {
                if (_this.log) {
                    console.log("store_group.updated received");
                    console.log(eventData.Body);
                }
                _this.StoreGroupUpdatedCallback(data);
            }
        });
        this.proxy.on("store_group.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreGroupDeletedCallback) {
                if (_this.log) {
                    console.log("store_group.deleted received");
                    console.log(eventData.Body);
                }
                _this.StoreGroupDeletedCallback(data);
            }
        });
    }
    StoreGroupHub.prototype.OnStoreGroupCreated = function (callback) {
        if (this.log) {
            console.log("store_group.created subscribed");
        }
        this.StoreGroupCreatedCallback = callback;
    };
    StoreGroupHub.prototype.OffStoreGroupCreated = function (callback) {
        if (this.log) {
            console.log("store_group.created unsubscribed");
        }
        this.StoreGroupCreatedCallback = undefined;
    };
    StoreGroupHub.prototype.OnStoreGroupUpdated = function (callback) {
        if (this.log) {
            console.log("store_group.updated subscribed");
        }
        this.StoreGroupUpdatedCallback = callback;
    };
    StoreGroupHub.prototype.OffStoreGroupUpdated = function (callback) {
        if (this.log) {
            console.log("store_group.updated unsubscribed");
        }
        this.StoreGroupUpdatedCallback = undefined;
    };
    StoreGroupHub.prototype.OnStoreGroupDeleted = function (callback) {
        if (this.log) {
            console.log("store_group.deleted subscribed");
        }
        this.StoreGroupDeletedCallback = callback;
    };
    StoreGroupHub.prototype.OffStoreGroupDeleted = function (callback) {
        if (this.log) {
            console.log("store_group.deleted unsubscribed");
        }
        this.StoreGroupDeletedCallback = undefined;
    };
    return StoreGroupHub;
}());
exports.StoreGroupHub = StoreGroupHub;
var StoreHub = (function () {
    function StoreHub(proxy, log) {
        var _this = this;
        this.StoreCreatedCallback = undefined;
        this.StoreUpdatedCallback = undefined;
        this.StoreArchivedCallback = undefined;
        this.StoreUnarchivedCallback = undefined;
        this.StorePublishedCallback = undefined;
        this.StoreUnpublishedCallback = undefined;
        this.StoreDeletedCallback = undefined;
        this.StoreAddressUpdatedCallback = undefined;
        this.StoreOpeningHoursUpdatedCallback = undefined;
        this.StoreMenuAssignedCallback = undefined;
        this.DeliveryZoneCreatedCallback = undefined;
        this.DeliveryZoneUpdatedCallback = undefined;
        this.DeliveryZoneDeletedCallback = undefined;
        this.StoreGroupCreatedCallback = undefined;
        this.StoreGroupUpdatedCallback = undefined;
        this.StoreGroupDeletedCallback = undefined;
        this.StoreBusinessHoursOverrideCreatedCallback = undefined;
        this.StoreBusinessHoursOverrideDeletedCallback = undefined;
        this.StorePreOrderConfigUpdatedCallback = undefined;
        this.StoreLogoCreatedCallback = undefined;
        this.StoreLogoUpdatedCallback = undefined;
        this.StoreLogoDeletedCallback = undefined;
        this.StoreKioskSettingUpdatedCallback = undefined;
        this.StoreFeeConfigUpdatedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("store.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreCreatedCallback) {
                if (_this.log) {
                    console.log("store.created received");
                    console.log(eventData.Body);
                }
                _this.StoreCreatedCallback(data);
            }
        });
        this.proxy.on("store.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreUpdatedCallback) {
                if (_this.log) {
                    console.log("store.updated received");
                    console.log(eventData.Body);
                }
                _this.StoreUpdatedCallback(data);
            }
        });
        this.proxy.on("store.archived", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreArchivedCallback) {
                if (_this.log) {
                    console.log("store.archived received");
                    console.log(eventData.Body);
                }
                _this.StoreArchivedCallback(data);
            }
        });
        this.proxy.on("store.unarchived", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreUnarchivedCallback) {
                if (_this.log) {
                    console.log("store.unarchived received");
                    console.log(eventData.Body);
                }
                _this.StoreUnarchivedCallback(data);
            }
        });
        this.proxy.on("store.published", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StorePublishedCallback) {
                if (_this.log) {
                    console.log("store.published received");
                    console.log(eventData.Body);
                }
                _this.StorePublishedCallback(data);
            }
        });
        this.proxy.on("store.unpublished", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreUnpublishedCallback) {
                if (_this.log) {
                    console.log("store.unpublished received");
                    console.log(eventData.Body);
                }
                _this.StoreUnpublishedCallback(data);
            }
        });
        this.proxy.on("store.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreDeletedCallback) {
                if (_this.log) {
                    console.log("store.deleted received");
                    console.log(eventData.Body);
                }
                _this.StoreDeletedCallback(data);
            }
        });
        this.proxy.on("store.address.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreAddressUpdatedCallback) {
                if (_this.log) {
                    console.log("store.address.updated received");
                    console.log(eventData.Body);
                }
                _this.StoreAddressUpdatedCallback(data);
            }
        });
        this.proxy.on("store.opening_hours.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreOpeningHoursUpdatedCallback) {
                if (_this.log) {
                    console.log("store.opening_hours.updated received");
                    console.log(eventData.Body);
                }
                _this.StoreOpeningHoursUpdatedCallback(data);
            }
        });
        this.proxy.on("store.menu.assigned", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreMenuAssignedCallback) {
                if (_this.log) {
                    console.log("store.menu.assigned received");
                    console.log(eventData.Body);
                }
                _this.StoreMenuAssignedCallback(data);
            }
        });
        this.proxy.on("store.delivery_zone.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.DeliveryZoneCreatedCallback) {
                if (_this.log) {
                    console.log("store.delivery_zone.created received");
                    console.log(eventData.Body);
                }
                _this.DeliveryZoneCreatedCallback(data);
            }
        });
        this.proxy.on("store.delivery_zone.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.DeliveryZoneUpdatedCallback) {
                if (_this.log) {
                    console.log("store.delivery_zone.updated received");
                    console.log(eventData.Body);
                }
                _this.DeliveryZoneUpdatedCallback(data);
            }
        });
        this.proxy.on("store.delivery_zone.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.DeliveryZoneDeletedCallback) {
                if (_this.log) {
                    console.log("store.delivery_zone.deleted received");
                    console.log(eventData.Body);
                }
                _this.DeliveryZoneDeletedCallback(data);
            }
        });
        this.proxy.on("store_group.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreGroupCreatedCallback) {
                if (_this.log) {
                    console.log("store_group.created received");
                    console.log(eventData.Body);
                }
                _this.StoreGroupCreatedCallback(data);
            }
        });
        this.proxy.on("store_group.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreGroupUpdatedCallback) {
                if (_this.log) {
                    console.log("store_group.updated received");
                    console.log(eventData.Body);
                }
                _this.StoreGroupUpdatedCallback(data);
            }
        });
        this.proxy.on("store_group.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreGroupDeletedCallback) {
                if (_this.log) {
                    console.log("store_group.deleted received");
                    console.log(eventData.Body);
                }
                _this.StoreGroupDeletedCallback(data);
            }
        });
        this.proxy.on("store.business_hours_override.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreBusinessHoursOverrideCreatedCallback) {
                if (_this.log) {
                    console.log("store.business_hours_override.created received");
                    console.log(eventData.Body);
                }
                _this.StoreBusinessHoursOverrideCreatedCallback(data);
            }
        });
        this.proxy.on("store.business_hours_override.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreBusinessHoursOverrideDeletedCallback) {
                if (_this.log) {
                    console.log("store.business_hours_override.deleted received");
                    console.log(eventData.Body);
                }
                _this.StoreBusinessHoursOverrideDeletedCallback(data);
            }
        });
        this.proxy.on("store.preorder_config.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StorePreOrderConfigUpdatedCallback) {
                if (_this.log) {
                    console.log("store.preorder_config.updated received");
                    console.log(eventData.Body);
                }
                _this.StorePreOrderConfigUpdatedCallback(data);
            }
        });
        this.proxy.on("store.logo.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreLogoCreatedCallback) {
                if (_this.log) {
                    console.log("store.logo.created received");
                    console.log(eventData.Body);
                }
                _this.StoreLogoCreatedCallback(data);
            }
        });
        this.proxy.on("store.logo.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreLogoUpdatedCallback) {
                if (_this.log) {
                    console.log("store.logo.updated received");
                    console.log(eventData.Body);
                }
                _this.StoreLogoUpdatedCallback(data);
            }
        });
        this.proxy.on("store.logo.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreLogoDeletedCallback) {
                if (_this.log) {
                    console.log("store.logo.deleted received");
                    console.log(eventData.Body);
                }
                _this.StoreLogoDeletedCallback(data);
            }
        });
        this.proxy.on("store.kiosk_setting.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreKioskSettingUpdatedCallback) {
                if (_this.log) {
                    console.log("store.kiosk_setting.updated received");
                    console.log(eventData.Body);
                }
                _this.StoreKioskSettingUpdatedCallback(data);
            }
        });
        this.proxy.on("store.fee_config.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.StoreFeeConfigUpdatedCallback) {
                if (_this.log) {
                    console.log("store.fee_config.updated received");
                    console.log(eventData.Body);
                }
                _this.StoreFeeConfigUpdatedCallback(data);
            }
        });
    }
    StoreHub.prototype.OnStoreCreated = function (callback) {
        if (this.log) {
            console.log("store.created subscribed");
        }
        this.StoreCreatedCallback = callback;
    };
    StoreHub.prototype.OffStoreCreated = function (callback) {
        if (this.log) {
            console.log("store.created unsubscribed");
        }
        this.StoreCreatedCallback = undefined;
    };
    StoreHub.prototype.OnStoreUpdated = function (callback) {
        if (this.log) {
            console.log("store.updated subscribed");
        }
        this.StoreUpdatedCallback = callback;
    };
    StoreHub.prototype.OffStoreUpdated = function (callback) {
        if (this.log) {
            console.log("store.updated unsubscribed");
        }
        this.StoreUpdatedCallback = undefined;
    };
    StoreHub.prototype.OnStoreArchived = function (callback) {
        if (this.log) {
            console.log("store.archived subscribed");
        }
        this.StoreArchivedCallback = callback;
    };
    StoreHub.prototype.OffStoreArchived = function (callback) {
        if (this.log) {
            console.log("store.archived unsubscribed");
        }
        this.StoreArchivedCallback = undefined;
    };
    StoreHub.prototype.OnStoreUnarchived = function (callback) {
        if (this.log) {
            console.log("store.unarchived subscribed");
        }
        this.StoreUnarchivedCallback = callback;
    };
    StoreHub.prototype.OffStoreUnarchived = function (callback) {
        if (this.log) {
            console.log("store.unarchived unsubscribed");
        }
        this.StoreUnarchivedCallback = undefined;
    };
    StoreHub.prototype.OnStorePublished = function (callback) {
        if (this.log) {
            console.log("store.published subscribed");
        }
        this.StorePublishedCallback = callback;
    };
    StoreHub.prototype.OffStorePublished = function (callback) {
        if (this.log) {
            console.log("store.published unsubscribed");
        }
        this.StorePublishedCallback = undefined;
    };
    StoreHub.prototype.OnStoreUnpublished = function (callback) {
        if (this.log) {
            console.log("store.unpublished subscribed");
        }
        this.StoreUnpublishedCallback = callback;
    };
    StoreHub.prototype.OffStoreUnpublished = function (callback) {
        if (this.log) {
            console.log("store.unpublished unsubscribed");
        }
        this.StoreUnpublishedCallback = undefined;
    };
    StoreHub.prototype.OnStoreDeleted = function (callback) {
        if (this.log) {
            console.log("store.deleted subscribed");
        }
        this.StoreDeletedCallback = callback;
    };
    StoreHub.prototype.OffStoreDeleted = function (callback) {
        if (this.log) {
            console.log("store.deleted unsubscribed");
        }
        this.StoreDeletedCallback = undefined;
    };
    StoreHub.prototype.OnStoreAddressUpdated = function (callback) {
        if (this.log) {
            console.log("store.address.updated subscribed");
        }
        this.StoreAddressUpdatedCallback = callback;
    };
    StoreHub.prototype.OffStoreAddressUpdated = function (callback) {
        if (this.log) {
            console.log("store.address.updated unsubscribed");
        }
        this.StoreAddressUpdatedCallback = undefined;
    };
    StoreHub.prototype.OnStoreOpeningHoursUpdated = function (callback) {
        if (this.log) {
            console.log("store.opening_hours.updated subscribed");
        }
        this.StoreOpeningHoursUpdatedCallback = callback;
    };
    StoreHub.prototype.OffStoreOpeningHoursUpdated = function (callback) {
        if (this.log) {
            console.log("store.opening_hours.updated unsubscribed");
        }
        this.StoreOpeningHoursUpdatedCallback = undefined;
    };
    StoreHub.prototype.OnStoreMenuAssigned = function (callback) {
        if (this.log) {
            console.log("store.menu.assigned subscribed");
        }
        this.StoreMenuAssignedCallback = callback;
    };
    StoreHub.prototype.OffStoreMenuAssigned = function (callback) {
        if (this.log) {
            console.log("store.menu.assigned unsubscribed");
        }
        this.StoreMenuAssignedCallback = undefined;
    };
    StoreHub.prototype.OnDeliveryZoneCreated = function (callback) {
        if (this.log) {
            console.log("store.delivery_zone.created subscribed");
        }
        this.DeliveryZoneCreatedCallback = callback;
    };
    StoreHub.prototype.OffDeliveryZoneCreated = function (callback) {
        if (this.log) {
            console.log("store.delivery_zone.created unsubscribed");
        }
        this.DeliveryZoneCreatedCallback = undefined;
    };
    StoreHub.prototype.OnDeliveryZoneUpdated = function (callback) {
        if (this.log) {
            console.log("store.delivery_zone.updated subscribed");
        }
        this.DeliveryZoneUpdatedCallback = callback;
    };
    StoreHub.prototype.OffDeliveryZoneUpdated = function (callback) {
        if (this.log) {
            console.log("store.delivery_zone.updated unsubscribed");
        }
        this.DeliveryZoneUpdatedCallback = undefined;
    };
    StoreHub.prototype.OnDeliveryZoneDeleted = function (callback) {
        if (this.log) {
            console.log("store.delivery_zone.deleted subscribed");
        }
        this.DeliveryZoneDeletedCallback = callback;
    };
    StoreHub.prototype.OffDeliveryZoneDeleted = function (callback) {
        if (this.log) {
            console.log("store.delivery_zone.deleted unsubscribed");
        }
        this.DeliveryZoneDeletedCallback = undefined;
    };
    StoreHub.prototype.OnStoreGroupCreated = function (callback) {
        if (this.log) {
            console.log("store_group.created subscribed");
        }
        this.StoreGroupCreatedCallback = callback;
    };
    StoreHub.prototype.OffStoreGroupCreated = function (callback) {
        if (this.log) {
            console.log("store_group.created unsubscribed");
        }
        this.StoreGroupCreatedCallback = undefined;
    };
    StoreHub.prototype.OnStoreGroupUpdated = function (callback) {
        if (this.log) {
            console.log("store_group.updated subscribed");
        }
        this.StoreGroupUpdatedCallback = callback;
    };
    StoreHub.prototype.OffStoreGroupUpdated = function (callback) {
        if (this.log) {
            console.log("store_group.updated unsubscribed");
        }
        this.StoreGroupUpdatedCallback = undefined;
    };
    StoreHub.prototype.OnStoreGroupDeleted = function (callback) {
        if (this.log) {
            console.log("store_group.deleted subscribed");
        }
        this.StoreGroupDeletedCallback = callback;
    };
    StoreHub.prototype.OffStoreGroupDeleted = function (callback) {
        if (this.log) {
            console.log("store_group.deleted unsubscribed");
        }
        this.StoreGroupDeletedCallback = undefined;
    };
    StoreHub.prototype.OnStoreBusinessHoursOverrideCreated = function (callback) {
        if (this.log) {
            console.log("store.business_hours_override.created subscribed");
        }
        this.StoreBusinessHoursOverrideCreatedCallback = callback;
    };
    StoreHub.prototype.OffStoreBusinessHoursOverrideCreated = function (callback) {
        if (this.log) {
            console.log("store.business_hours_override.created unsubscribed");
        }
        this.StoreBusinessHoursOverrideCreatedCallback = undefined;
    };
    StoreHub.prototype.OnStoreBusinessHoursOverrideDeleted = function (callback) {
        if (this.log) {
            console.log("store.business_hours_override.deleted subscribed");
        }
        this.StoreBusinessHoursOverrideDeletedCallback = callback;
    };
    StoreHub.prototype.OffStoreBusinessHoursOverrideDeleted = function (callback) {
        if (this.log) {
            console.log("store.business_hours_override.deleted unsubscribed");
        }
        this.StoreBusinessHoursOverrideDeletedCallback = undefined;
    };
    StoreHub.prototype.OnStorePreOrderConfigUpdated = function (callback) {
        if (this.log) {
            console.log("store.preorder_config.updated subscribed");
        }
        this.StorePreOrderConfigUpdatedCallback = callback;
    };
    StoreHub.prototype.OffStorePreOrderConfigUpdated = function (callback) {
        if (this.log) {
            console.log("store.preorder_config.updated unsubscribed");
        }
        this.StorePreOrderConfigUpdatedCallback = undefined;
    };
    StoreHub.prototype.OnStoreLogoCreated = function (callback) {
        if (this.log) {
            console.log("store.logo.created subscribed");
        }
        this.StoreLogoCreatedCallback = callback;
    };
    StoreHub.prototype.OffStoreLogoCreated = function (callback) {
        if (this.log) {
            console.log("store.logo.created unsubscribed");
        }
        this.StoreLogoCreatedCallback = undefined;
    };
    StoreHub.prototype.OnStoreLogoUpdated = function (callback) {
        if (this.log) {
            console.log("store.logo.updated subscribed");
        }
        this.StoreLogoUpdatedCallback = callback;
    };
    StoreHub.prototype.OffStoreLogoUpdated = function (callback) {
        if (this.log) {
            console.log("store.logo.updated unsubscribed");
        }
        this.StoreLogoUpdatedCallback = undefined;
    };
    StoreHub.prototype.OnStoreLogoDeleted = function (callback) {
        if (this.log) {
            console.log("store.logo.deleted subscribed");
        }
        this.StoreLogoDeletedCallback = callback;
    };
    StoreHub.prototype.OffStoreLogoDeleted = function (callback) {
        if (this.log) {
            console.log("store.logo.deleted unsubscribed");
        }
        this.StoreLogoDeletedCallback = undefined;
    };
    StoreHub.prototype.OnStoreKioskSettingUpdated = function (callback) {
        if (this.log) {
            console.log("store.kiosk_setting.updated subscribed");
        }
        this.StoreKioskSettingUpdatedCallback = callback;
    };
    StoreHub.prototype.OffStoreKioskSettingUpdated = function (callback) {
        if (this.log) {
            console.log("store.kiosk_setting.updated unsubscribed");
        }
        this.StoreKioskSettingUpdatedCallback = undefined;
    };
    StoreHub.prototype.OnStoreFeeConfigUpdated = function (callback) {
        if (this.log) {
            console.log("store.fee_config.updated subscribed");
        }
        this.StoreFeeConfigUpdatedCallback = callback;
    };
    StoreHub.prototype.OffStoreFeeConfigUpdated = function (callback) {
        if (this.log) {
            console.log("store.fee_config.updated unsubscribed");
        }
        this.StoreFeeConfigUpdatedCallback = undefined;
    };
    return StoreHub;
}());
exports.StoreHub = StoreHub;
var TeammateHub = (function () {
    function TeammateHub(proxy, log) {
        var _this = this;
        this.TeammateInviteSentCallback = undefined;
        this.TeammateInviteAcceptedCallback = undefined;
        this.TeammateUpdatedCallback = undefined;
        this.TeammateDeletedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("teammate.invite.sent", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.TeammateInviteSentCallback) {
                if (_this.log) {
                    console.log("teammate.invite.sent received");
                    console.log(eventData.Body);
                }
                _this.TeammateInviteSentCallback(data);
            }
        });
        this.proxy.on("teammate.invite.accepted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.TeammateInviteAcceptedCallback) {
                if (_this.log) {
                    console.log("teammate.invite.accepted received");
                    console.log(eventData.Body);
                }
                _this.TeammateInviteAcceptedCallback(data);
            }
        });
        this.proxy.on("teammate.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.TeammateUpdatedCallback) {
                if (_this.log) {
                    console.log("teammate.updated received");
                    console.log(eventData.Body);
                }
                _this.TeammateUpdatedCallback(data);
            }
        });
        this.proxy.on("teammate.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.TeammateDeletedCallback) {
                if (_this.log) {
                    console.log("teammate.deleted received");
                    console.log(eventData.Body);
                }
                _this.TeammateDeletedCallback(data);
            }
        });
    }
    TeammateHub.prototype.OnTeammateInviteSent = function (callback) {
        if (this.log) {
            console.log("teammate.invite.sent subscribed");
        }
        this.TeammateInviteSentCallback = callback;
    };
    TeammateHub.prototype.OffTeammateInviteSent = function (callback) {
        if (this.log) {
            console.log("teammate.invite.sent unsubscribed");
        }
        this.TeammateInviteSentCallback = undefined;
    };
    TeammateHub.prototype.OnTeammateInviteAccepted = function (callback) {
        if (this.log) {
            console.log("teammate.invite.accepted subscribed");
        }
        this.TeammateInviteAcceptedCallback = callback;
    };
    TeammateHub.prototype.OffTeammateInviteAccepted = function (callback) {
        if (this.log) {
            console.log("teammate.invite.accepted unsubscribed");
        }
        this.TeammateInviteAcceptedCallback = undefined;
    };
    TeammateHub.prototype.OnTeammateUpdated = function (callback) {
        if (this.log) {
            console.log("teammate.updated subscribed");
        }
        this.TeammateUpdatedCallback = callback;
    };
    TeammateHub.prototype.OffTeammateUpdated = function (callback) {
        if (this.log) {
            console.log("teammate.updated unsubscribed");
        }
        this.TeammateUpdatedCallback = undefined;
    };
    TeammateHub.prototype.OnTeammateDeleted = function (callback) {
        if (this.log) {
            console.log("teammate.deleted subscribed");
        }
        this.TeammateDeletedCallback = callback;
    };
    TeammateHub.prototype.OffTeammateDeleted = function (callback) {
        if (this.log) {
            console.log("teammate.deleted unsubscribed");
        }
        this.TeammateDeletedCallback = undefined;
    };
    return TeammateHub;
}());
exports.TeammateHub = TeammateHub;
var VoucherHub = (function () {
    function VoucherHub(proxy, log) {
        var _this = this;
        this.VoucherCreatedCallback = undefined;
        this.VoucherDeletedCallback = undefined;
        this.VoucherUpdatedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("voucher.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.VoucherCreatedCallback) {
                if (_this.log) {
                    console.log("voucher.created received");
                    console.log(eventData.Body);
                }
                _this.VoucherCreatedCallback(data);
            }
        });
        this.proxy.on("voucher.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.VoucherDeletedCallback) {
                if (_this.log) {
                    console.log("voucher.deleted received");
                    console.log(eventData.Body);
                }
                _this.VoucherDeletedCallback(data);
            }
        });
        this.proxy.on("voucher.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.VoucherUpdatedCallback) {
                if (_this.log) {
                    console.log("voucher.updated received");
                    console.log(eventData.Body);
                }
                _this.VoucherUpdatedCallback(data);
            }
        });
    }
    VoucherHub.prototype.OnVoucherCreated = function (callback) {
        if (this.log) {
            console.log("voucher.created subscribed");
        }
        this.VoucherCreatedCallback = callback;
    };
    VoucherHub.prototype.OffVoucherCreated = function (callback) {
        if (this.log) {
            console.log("voucher.created unsubscribed");
        }
        this.VoucherCreatedCallback = undefined;
    };
    VoucherHub.prototype.OnVoucherDeleted = function (callback) {
        if (this.log) {
            console.log("voucher.deleted subscribed");
        }
        this.VoucherDeletedCallback = callback;
    };
    VoucherHub.prototype.OffVoucherDeleted = function (callback) {
        if (this.log) {
            console.log("voucher.deleted unsubscribed");
        }
        this.VoucherDeletedCallback = undefined;
    };
    VoucherHub.prototype.OnVoucherUpdated = function (callback) {
        if (this.log) {
            console.log("voucher.updated subscribed");
        }
        this.VoucherUpdatedCallback = callback;
    };
    VoucherHub.prototype.OffVoucherUpdated = function (callback) {
        if (this.log) {
            console.log("voucher.updated unsubscribed");
        }
        this.VoucherUpdatedCallback = undefined;
    };
    return VoucherHub;
}());
exports.VoucherHub = VoucherHub;
var WebhookHub = (function () {
    function WebhookHub(proxy, log) {
        var _this = this;
        this.WebhookSubscriptionCreatedCallback = undefined;
        this.WebhookSubscriptionUpdatedCallback = undefined;
        this.WebhookSubscriptionDeletedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("webhook_subscription.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.WebhookSubscriptionCreatedCallback) {
                if (_this.log) {
                    console.log("webhook_subscription.created received");
                    console.log(eventData.Body);
                }
                _this.WebhookSubscriptionCreatedCallback(data);
            }
        });
        this.proxy.on("webhook_subscription.updated", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.WebhookSubscriptionUpdatedCallback) {
                if (_this.log) {
                    console.log("webhook_subscription.updated received");
                    console.log(eventData.Body);
                }
                _this.WebhookSubscriptionUpdatedCallback(data);
            }
        });
        this.proxy.on("webhook_subscription.deleted", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.WebhookSubscriptionDeletedCallback) {
                if (_this.log) {
                    console.log("webhook_subscription.deleted received");
                    console.log(eventData.Body);
                }
                _this.WebhookSubscriptionDeletedCallback(data);
            }
        });
    }
    WebhookHub.prototype.OnWebhookSubscriptionCreated = function (callback) {
        if (this.log) {
            console.log("webhook_subscription.created subscribed");
        }
        this.WebhookSubscriptionCreatedCallback = callback;
    };
    WebhookHub.prototype.OffWebhookSubscriptionCreated = function (callback) {
        if (this.log) {
            console.log("webhook_subscription.created unsubscribed");
        }
        this.WebhookSubscriptionCreatedCallback = undefined;
    };
    WebhookHub.prototype.OnWebhookSubscriptionUpdated = function (callback) {
        if (this.log) {
            console.log("webhook_subscription.updated subscribed");
        }
        this.WebhookSubscriptionUpdatedCallback = callback;
    };
    WebhookHub.prototype.OffWebhookSubscriptionUpdated = function (callback) {
        if (this.log) {
            console.log("webhook_subscription.updated unsubscribed");
        }
        this.WebhookSubscriptionUpdatedCallback = undefined;
    };
    WebhookHub.prototype.OnWebhookSubscriptionDeleted = function (callback) {
        if (this.log) {
            console.log("webhook_subscription.deleted subscribed");
        }
        this.WebhookSubscriptionDeletedCallback = callback;
    };
    WebhookHub.prototype.OffWebhookSubscriptionDeleted = function (callback) {
        if (this.log) {
            console.log("webhook_subscription.deleted unsubscribed");
        }
        this.WebhookSubscriptionDeletedCallback = undefined;
    };
    return WebhookHub;
}());
exports.WebhookHub = WebhookHub;
var WebsiteHub = (function () {
    function WebsiteHub(proxy, log) {
        var _this = this;
        this.CertificateRenewedCallback = undefined;
        this.CertificateCreatedCallback = undefined;
        this.DnsVerifiedCallback = undefined;
        this.proxy = proxy;
        this.log = log;
        this.proxy.on("website.certificate.renewed", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.CertificateRenewedCallback) {
                if (_this.log) {
                    console.log("website.certificate.renewed received");
                    console.log(eventData.Body);
                }
                _this.CertificateRenewedCallback(data);
            }
        });
        this.proxy.on("website.certificate.created", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.CertificateCreatedCallback) {
                if (_this.log) {
                    console.log("website.certificate.created received");
                    console.log(eventData.Body);
                }
                _this.CertificateCreatedCallback(data);
            }
        });
        this.proxy.on("website.dns.verified", function (eventData) {
            var data = JSON.parse(eventData.Body);
            if (_this.DnsVerifiedCallback) {
                if (_this.log) {
                    console.log("website.dns.verified received");
                    console.log(eventData.Body);
                }
                _this.DnsVerifiedCallback(data);
            }
        });
    }
    WebsiteHub.prototype.OnCertificateRenewed = function (callback) {
        if (this.log) {
            console.log("website.certificate.renewed subscribed");
        }
        this.CertificateRenewedCallback = callback;
    };
    WebsiteHub.prototype.OffCertificateRenewed = function (callback) {
        if (this.log) {
            console.log("website.certificate.renewed unsubscribed");
        }
        this.CertificateRenewedCallback = undefined;
    };
    WebsiteHub.prototype.OnCertificateCreated = function (callback) {
        if (this.log) {
            console.log("website.certificate.created subscribed");
        }
        this.CertificateCreatedCallback = callback;
    };
    WebsiteHub.prototype.OffCertificateCreated = function (callback) {
        if (this.log) {
            console.log("website.certificate.created unsubscribed");
        }
        this.CertificateCreatedCallback = undefined;
    };
    WebsiteHub.prototype.OnDnsVerified = function (callback) {
        if (this.log) {
            console.log("website.dns.verified subscribed");
        }
        this.DnsVerifiedCallback = callback;
    };
    WebsiteHub.prototype.OffDnsVerified = function (callback) {
        if (this.log) {
            console.log("website.dns.verified unsubscribed");
        }
        this.DnsVerifiedCallback = undefined;
    };
    return WebsiteHub;
}());
exports.WebsiteHub = WebsiteHub;
//# sourceMappingURL=api.js.map